<template>
  <div></div>
</template>

<script>
export default {
  created() {
    this.$emit('toggleMoreFilters', true)
  }
}
</script>
